import React from 'react';

const ResearchReductionForm = ({ isOpen, onClose, onSubmit, name, setName, score, setScore, categoryType, setCategoryType, isEditing }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1050 }}>
            <div className="modal-box" style={{ width: '90%', maxWidth: '650px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '20px', lineHeight: '1.4' }}>
                        <i className={isEditing ? "fa-solid fa-pen-to-square" : "fa-solid fa-plus-circle"} style={{ marginRight: '8px' }}></i>
                        {isEditing ? "Cập nhật Giảm trừ" : "Thêm mới Danh mục"}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="researchReductionForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Nhóm phân loại để tính điểm <span className="text-red">*</span>
                            </label>
                            <select
                                className="form-input"
                                style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                                value={categoryType}
                                onChange={(e) => setCategoryType(Number(e.target.value))}
                            >
                                <option value={1}>Loại 1: Chức vụ / Công việc</option>
                                <option value={2}>Loại 2: Đi học / Bồi dưỡng</option>
                                <option value={3}>Loại 3: Thai sản / Nghỉ chế độ</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Nội dung chi tiết <span className="text-red">*</span>
                            </label>
                            <textarea
                                className="form-input"
                                rows="3"
                                style={{ resize: 'vertical' }}
                                placeholder="Nhập chức danh/nội dung giảm trừ"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Tỉ lệ giảm (%) <span className="text-red">*</span>
                            </label>
                            <input
                                type="number"
                                className="form-input"
                                placeholder="Nhập tỉ lệ"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                            />
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>
                        <i className="fa-solid fa-xmark" style={{ marginRight: '6px' }}></i> Hủy
                    </button>
                    <button type="submit" form="researchReductionForm" className="btn-submit">
                        <i className="fa-solid fa-check" style={{ marginRight: '6px' }}></i> Hoàn tất
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResearchReductionForm;